var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import "../../../utils/FlightRoute.utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { constructQueryString, getFlightQueryParams } from "@ane/exp-data/lib/routes/FlightRoute.utils";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class FlightResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api");
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      return response && response.ExceptionMessage;
    });
  }
  _v2APIPath(tenantId) {
    return `/2.0/tenants/${tenantId}/flights/`;
  }
  loadFlightTreatmentVariablesV2(flightId, workspaceId, managementGroup, tenant) {
    return __async(this, null, function* () {
      const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
      const address = `${this._v2APIPath(tenant)}${flightId}/variables${queryString}`;
      const result = yield this._get(address);
      return result.getSuccessData(this._errorMessage);
    });
  }
  loadFlightOverview(flightId, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const params = [`flightName=${flightId}`, ...getFlightQueryParams(managementGroup, workspaceId)];
      const queryString = constructQueryString(params);
      const address = `/flight/overview/${queryString}`;
      return yield this._get(address);
    });
  }
  loadFlightTraffic(flightId, managementGroup, workspaceId, skipIndirectTraffic = true) {
    return __async(this, null, function* () {
      const params = [
        `flightName=${flightId}`,
        `skipIndirectTraffic=${skipIndirectTraffic}`,
        ...getFlightQueryParams(managementGroup, workspaceId)
      ];
      const queryString = constructQueryString(params);
      const address = `/flight/traffic/${queryString}`;
      const result = yield this._get(address);
      return result.getSuccessData(this._errorMessage);
    });
  }
  updateFlight(flightId, workspaceId, managementGroup, tenant, flightConfig) {
    return __async(this, null, function* () {
      const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
      const address = `${this._v2APIPath(tenant)}${flightId}${queryString}`;
      const result = yield this._put(flightConfig, address);
      return result.ensureSuccess(this._errorMessage);
    });
  }
  createFlights(tenant, workspaceId, flightConfigurations) {
    return __async(this, null, function* () {
      const address = `${this._v2APIPath(tenant)}batch?workspaceId=${workspaceId}`;
      const result = yield this._post(flightConfigurations, address);
      return result;
    });
  }
}
__decorateClass([
  onError({ message: `An error occurred.` })
], FlightResource.prototype, "loadFlightTreatmentVariablesV2", 1);
__decorateClass([
  onError({ message: `An error occurred.` })
], FlightResource.prototype, "loadFlightOverview", 1);
__decorateClass([
  onError({ message: `An error occured when loading flight traffic.` })
], FlightResource.prototype, "loadFlightTraffic", 1);
const FlightResource$1 = new FlightResource();
export {
  FlightResource$1 as default
};
//# sourceMappingURL=Flight.resource.js.map
